export default {
    // 通用标签列表
    tags: {
        method: 'get',
        url: '/common/tags'
    },
    // 产品分类列表
    productCategories: {
        method: 'get',
        url: '/dictionaries/product_categories'
    },
    // 标签类型列表
    tagTypes: {
        method: 'get',
        url: '/common/tag_types'
    },
    // 获取服务类型选项列表
    serviceTypes: {
        method: 'get',
        url: '/common/product_service_types/:id'
    },
    // 区域列表
    areas: {
        method: 'get',
        url: '/common/areas'
    },
    // 文件上传
    uploadFilesMultiple: {
        method: 'post',
        url: '/common/upload/files/multi'
    }     
};



// WEBPACK FOOTER //
// ./src/api/common.js